import { NOT_FOUND } from 'http-status';

export const getError = (code, ...args) => {
  if (!code) {
    return;
  }

  return { code, args };
};

export const getNotFoundError = (...args) => getError(NOT_FOUND, ...args);
